import * as React from 'react';
import {
  UploadBlockedProductReasonFilePayload,
  UploadBockedProductFilePayload,
  UploadBlockedProductPricesFilePayload,
  UploadPlannerAndMaterialFilePayload, UploadDestinationPlantMaterialsFilePayload,
} from 'contracts/blocked-products';
import { api, handleApiError } from 'services';

export const useUploadBlockedProductFiles = () => {
  const uploadProductsFile = React.useCallback(
    async (payload: UploadBockedProductFilePayload) => {
      const formData = new FormData();
      formData.append('file', payload.file, payload.file.name);
      try {
        await api.post('/inventory/blocked-products', formData);
      } catch (e) {
        throw handleApiError(e);
      }
    }, []);

  const uploadProductPricesFile = React.useCallback
  (async (payload: UploadBlockedProductPricesFilePayload) => {
    const formData = new FormData();
    formData.append('file', payload.file, payload.file.name);
    try {
      await api.post('/inventory/product-prices', formData);
    } catch (e) {
      throw handleApiError(e);
    }
  }, []);

  const uploadProductReasonsFile = React.useCallback(
    async (payload: UploadBlockedProductReasonFilePayload) => {
      const formData = new FormData();
      formData.append('file', payload.file, payload.file.name);
      try {
        await api.put('/inventory/import-blocked-product-reasons', formData);
      } catch (e) {
        throw handleApiError(e);
      }
    }, []);

  const uploadDestinationPlantMaterialsFile = React.useCallback(async (payload: UploadDestinationPlantMaterialsFilePayload) => {
    const formData = new FormData();
    formData.append('file', payload.file, payload.file.name);
    try {
      await api.put('/inventory/import-destination-plant-materials', formData);
    } catch (e) {
      throw handleApiError(e);
    }
  }, []);

  const uploadPlannerAndMaterialFile = React.useCallback(
    async (payload: UploadPlannerAndMaterialFilePayload) => {
      const formData = new FormData();
      formData.append('file', payload.file, payload.file.name);
      try {
        await api.put('/planners/import-planner-and-material', formData);
      } catch (e) {
        throw handleApiError(e);
      }
    }, []);

  return {
    uploadProductsFile,
    uploadProductPricesFile,
    uploadProductReasonsFile,
    uploadDestinationPlantMaterialsFile,
    uploadPlannerAndMaterialFile,
  };
};